import _defineProperty from "/codebuild/output/src2417502137/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/codebuild/output/src2417502137/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from "react";
import dynamic from "next/dynamic";
import UseWindowSize from "../hooks/UseWindowSize";
import { jsx as _jsx } from "react/jsx-runtime";
var MapLeaflet;

var Map = function Map(props) {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      mapLoaded = _React$useState2[0],
      setMapLoaded = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      dragging = _React$useState4[0],
      setDragging = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      tap = _React$useState6[0],
      setTap = _React$useState6[1];

  var size = UseWindowSize();
  React.useEffect(function () {
    MapLeaflet = dynamic(function () {
      return import("../components/MapLeaflet");
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [require.resolveWeak("../components/MapLeaflet")];
        },
        modules: ["../components/Map.js -> " + "../components/MapLeaflet"]
      }
    });
    setMapLoaded(true);
  }, []);
  React.useEffect(function () {
    if (mapLoaded) {
      // setTap(size.width > 700)
      setDragging(size.width > 700);
    }
  }, [size, mapLoaded]);
  return mapLoaded ? /*#__PURE__*/_jsx(MapLeaflet, _objectSpread({
    dragging: dragging,
    tap: tap
  }, props)) : /*#__PURE__*/_jsx("p", {
    children: "loading"
  });
};

export default Map;